module.exports = __webpack_public_path__ + "media/images/529s/apple-touch-icon-76x76-0f6595d89562761c24cef0d1b4392eaa.png";